import { createContext, useContext, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps -- load session once on mount

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    setUser(r.data);
    return r.data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { if (process.env.NODE_ENV !== "production") console.warn("Logout request failed:", e); }
    setUser(null);
  };

  const perms = user?.permissions || { view: [], edit: [], actions: [] };
  const can = (a) => perms.actions.includes(a);
  const canView = (f) => perms.view.includes(f);
  const canEdit = (f) => perms.edit.includes(f);

  const value = useMemo(
    () => ({ user, loading, login, logout, can, canView, canEdit, setUser }),
    [user, loading] // eslint-disable-line react-hooks/exhaustive-deps -- login/logout/can* are stable module-closure fns
  );

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
